import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import styles from './styles/_business-page-header.scss';
import {UploadImage} from 'components/UI/Image';

class BusinessPageHeader extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      bannerSRC: require('assets/images/company/banner-blue.jpg')
    };
  }
  render() {

    return (
      <div className='banner-top business-page-header' style={{backgroundImage: `url(${this.state.bannerSRC})`, color: '#fff'}}>
        <div className='logo-wrapper'>
          <UploadImage type="BUSINESS" transform="crop" className='business-logo' width="118" height="118" image={this.props.business.logo}/>
        </div>
        <div className='business-detail'>
          <h2 className='business-name'>{this.props.business.name}</h2>
          <div className='business-contact-info'>
            <p>Email: {this.props.business.email}</p>
            <p>Mã số thuế: {this.props.business.taxCode}</p>
            <p>Điện thoại: {this.props.business.phone}</p>
            <p>Người liên hệ: {this.props.business.contactName}</p>
          </div>
          {/* <p className='business-des'>{this.props.business.description}</p> */}
        </div>
        {
          this.props.business.portfolioLink &&
          (
            <div className='portfolio enabled'>
              <button className='btnViewPorfolio'
                onClick={() => {
                  window.open(this.props.business.portfolioLink, "_blank");
                }}
              >HỒ SƠ NĂNG LỰC ONLINE</button>
            </div>
          )
        }
        {
          !this.props.business.portfolioLink &&
          (
            <div className='portfolio disabled'>
              <button className='btnViewPorfolio'>HỒ SƠ NĂNG LỰC ONLINE<br/>(ĐANG CẬP NHẬT)</button>
            </div>
          )
        }
      </div>
    );
  }
}

BusinessPageHeader.propTypes = {
  business: PropTypes.object.isRequired
};

export default BusinessPageHeader;



// WEBPACK FOOTER //
// ./components/business/business-page/BusinessPageHeader.jsx